module.exports = __webpack_public_path__ + "static/fow-exp-d17e3cfa8491b5154aee9bd399aebbf2.svg";